import axios from 'axios';

export const getCompanyDepartments = async (lang) => {
  const { data } = await axios.get(`/company-departments?lang=${lang}`);

  return data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
};
